import React from 'react';

import { ReactComponent as VideoOutline } from '../../images/backgrounds/multicolor-gradient-bold.svg';
import ContentfulImage from '../Common/ContentfulImage';
import SmartLink from '../Common/SmartLink';
import { AutoPauseVideo } from '../Generic/AutoPauseVideo';
import HeadingCtas from '../Generic/HeadingCtas';
import PageSection from '../PageSections/PageSection';
import * as styles from './StylizedHeadlineHeader.module.scss';

export default function StylizedHeadlineHeader({ fields }) {
  let bgColor;
  switch (fields.backgroundColor) {
    case 'evergreen deep': {
      bgColor = styles.evergreenDeep;
      break;
    }
    default: {
      bgColor = '';
      break;
    }
  }

  const heroImage = (
    <>
      {fields.headingImageBackground && (
        <ContentfulImage imageFragment={fields.headingImageBackground} fetchpriority={'high'} />
      )}
      {fields.headingImage && <ContentfulImage imageFragment={fields.headingImage} fetchpriority={'high'} />}
    </>
  );

  return (
    <PageSection
      isTopSection
      className={[styles.stylizedHeadlineHeader, bgColor].join(' ')}
      innerClassName={styles.columns}
      data-analytics-section={'stylized-headline-header'}
    >
      <div className={styles.content}>
        <ContentfulImage
          imageFragment={fields.stylizedHeading}
          className={styles.stylizedHeading}
          style={{ translate: `${fields.headlineLeftOffset}%` }}
          fetchpriority={'high'}
        />
        <h1>{fields.introCopy}</h1>
        {fields.headingCtAs && <HeadingCtas ctas={fields.headingCtAs} className={styles.ctas} />}
      </div>
      {fields.videoUrl && (
        <div className={styles.videoWrapper}>
          <VideoOutline className={styles.videoOutline} />
          <AutoPauseVideo src={fields.videoUrl} classes={[styles.video]} />
        </div>
      )}
      {fields.imageLink ? (
        <SmartLink to={fields.imageLink} className={styles.headingImage}>
          {heroImage}
        </SmartLink>
      ) : (
        <div className={styles.headingImage}>{heroImage}</div>
      )}
    </PageSection>
  );
}
